//
//
//
//

export default {
  name: "Item",
  created() {},
  props: ["text"],
  data() {
    return {};
  },
  methods: {}
};



// WEBPACK FOOTER //
// ./src/components/More.vue